export interface UserInfo {
  id?: number;
  name?: string;
  email?: string;
  phone?: string;
  signupMethod?: string;
  accountId?: number;
}

export interface UserState {
  user?: UserInfo;
}

const state: UserState = {
  user: {
    name: undefined,
    email: undefined,
    phone: undefined,
    signupMethod: undefined,
    accountId: undefined,
  },
};

export default state;
